<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <i class="mdi mdi-close font-20 cursor-pointer float-end" (click)="activeModal.dismiss()"></i>
</div>

<div class="modal-body">
  <p>{{ content }}</p>
</div>

<div class="modal-footer mt-1rem">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
    {{ 'Labels.PaymentDetailsPage.Reject' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="termsAccepted = true; activeModal.close()">
    {{ 'Labels.PaymentDetailsPage.Accept' | translate }}
  </button>
</div>
